import {
  configureStore,
  Action,
  combineReducers,
  createAction,
} from "@reduxjs/toolkit";

import { userSlice } from "./user/user.slice";
import { clientsSlice } from "./clients/clients.slice";
import authSlice from "./slices/auth.slice";
import { feedbackSlice } from "./feedback/feedback.slice";
import { resourcesSlice } from "./resources/resources.slice";

const appReducer = combineReducers({
  user: userSlice.reducer,
  clients: clientsSlice.reducer,
  feedback: feedbackSlice.reducer,
  auth: authSlice,
  resources: resourcesSlice.reducer,
});

export const rootReducer = (state: any, action: Action<string>) => {
  if (action.type === "RESET_STATE") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  devTools: true,
});

export const restoreReduxState = createAction("RESET_STATE");
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export default store;
